import { useEffect, RefObject } from 'react';

const useScrollIntoView = (ref: RefObject<HTMLElement>, dependencies: any[]) => {
  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && ref.current) {
          ref.current.scrollIntoView({ behavior: 'smooth' });
          observer.disconnect(); 
        }
      });
    });

    if (ref.current) {
      observer.observe(ref.current, { childList: true, subtree: true });
    }

    return () => {
      observer.disconnect(); 
    };
  }, dependencies); 
};

export default useScrollIntoView;
